module.exports = __webpack_public_path__ + "media/images/amenities_icons/outdoor_terrace-b317488426724bfddbe7e3fdcaa87c71.svg";